import styled from 'styled-components';

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  height: 100%;
  flex: 1;
`;

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  margin: 0 auto;
  padding: 40px 16px;
`;

const Inner = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 48px;
`;
const HeaderBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  gap: 24px;
  color: #616161;
  font-size: 18px;
  font-family: 'Spoqa Han Sans Neo', 'sans-serif';
  font-weight: 500;
  line-height: 26.1px;
  word-wrap: break-word;
  justify-content: center;
  div {
    text-align: center;
  }
  span {
    color: #222222;
    font-size: 24px;
    font-family: 'Spoqa Han Sans Neo', 'sans-serif';
    font-weight: 700;
    line-height: 34.8px;
  }
`;

const SignUpTabWrapper = styled.div`
  display: flex;
  flex-direction: row;
`;

const SignUpTabBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 50%;
  position: relative;
  padding: 12px 40px;
`;

interface SignUpTabProps {
  isActive: boolean;
}

const SignUpTabButton = styled.div<SignUpTabProps>`
  color: ${(props) => (props.isActive ? '#283b64' : 'rgba(40, 59, 100, 0.34)')};
  font-size: 18px;
  font-family: 'Spoqa Han Sans Neo', 'sans-serif';
  font-weight: 700;
  line-height: 26.1px;
  word-wrap: break-word;
  cursor: pointer;
`;

const SignUpRow = styled.div<SignUpTabProps>`
  display: ${(props) => (props.isActive ? 'block' : 'none')};
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 3px;
  background-color: #008aff;
`;

const SignUpButtonBox = styled.div`
  width: 100%;
  height: 54px;
  border-radius: 8px;
  padding: 14px 28px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-size: 16px;
  font-family: 'Spoqa Han Sans Neo', 'sans-serif';
  font-weight: 700;
  line-height: 26.4px;
  word-wrap: break-word;
  background-color: #008aff;
  cursor: pointer;
`;

const SocialLogin = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const LineBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 8px;
  font-family: 'Spoqa Han Sans Neo', 'sans-serif';
  font-weight: 500;
  font-size: 12px;
  color: rgba(55, 56, 60, 0.61);
`;

const Line = styled.div`
  height: 1px;
  display: flex;
  flex: 1;
  background-color: rgba(112, 115, 124, 0.22);
`;

const LogoBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;
`;
const Img = styled.img`
  cursor: pointer;
`;

const VisibleButton = styled.div`
  position: absolute;
  top: 53px;
  right: 15px;
  img {
    width: 20px;
    height: 20px;
  }
`;
interface ValidProps {
  isValid: boolean;
  sendYN?: boolean;
  available?: boolean;
  text?: string;
}

const InputInfoBox = styled.div<ValidProps>`
  color: ${(props) => (props.isValid ? 'rgba(55, 56, 60, 0.61)' : '#FF0000')};
  display: flex;
  flex-direction: row;
  gap: 6px;
  font-size: 13px;
  font-family: Spoqa Han Sans Neo;
  font-weight: 500;
  line-height: 20.3px;
  word-wrap: break-word;
`;

export const S = {
  SocialLogin,
  Img,
  LogoBox,
  Line,
  LineBox,
  SignUpButtonBox,
  SignUpRow,
  SignUpTabButton,
  SignUpTabBox,
  SignUpTabWrapper,
  Wrapper,
  Container,
  HeaderBox,
  Inner,
  VisibleButton,
  InputInfoBox,
};
